module.exports = __webpack_public_path__ + "img/arrow-circle-left.4324c572.svg";